import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from 'echarts'
import VConsole from 'vconsole';
import './plugins/axios'
import './plugins/vant'
import './plugins/antd'
import './plugins/utils'
import './plugins/components'
import './plugins/amfe'
import './assets/css/theme.less'
import './registerServiceWorker'

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
